// biome-ignore lint/suspicious/noExplicitAny: let it go
const _eventHandlers = {};
/**
 * Subscribe to an event
 *
 * @param group The group this event belongs to e.g. 'session'
 * @param eventName The name of this event e.g. 'ended'
 * @param handler The handler that will be called when the event is emitted
 * @returns Function to remove event handler
 */
export function onEvent(group, eventName, handler) {
    const eventKey = `${String(group)}.${String(eventName)}`;
    _eventHandlers[eventKey] = [...(_eventHandlers[eventKey] || []), handler];
    return () => offEvent(group, eventName, handler);
}
/**
 * Subscribe to an event once.
 *
 * @param group The group this event belongs to e.g. 'session'
 * @param eventName The name of this event e.g. 'ended'
 * @param handler The handler that will be called when the event is emitted
 * @returns Function to remove event handler
 */
export function onceEvent(group, eventName, handler) {
    const offEvent = onEvent(group, eventName, (a) => {
        handler(a);
        // Immediately remove handler after firing once
        offEvent();
    });
    return offEvent;
}
/**
 * Unsubscribe from an event
 *
 * @param group The group the event belongs to e.g. 'session'
 * @param eventName The name of the event e.g. 'ended'
 * @param handler The handler that needs to be detached
 */
export function offEvent(group, eventName, handler) {
    var _a;
    const eventKey = `${String(group)}.${String(eventName)}`;
    _eventHandlers[eventKey] = ((_a = _eventHandlers[eventKey]) !== null && _a !== void 0 ? _a : []).filter((fn) => {
        return fn !== handler;
    });
}
/**
 * Emit an event
 *
 * @param group The group the event belongs to e.g. 'session'
 * @param eventName The name of the event e.g. 'started'
 * @param value The value that should be emitted e.g. 'Session' which calls all listeners with 'value: Session'
 */
export function emitEvent(group, eventName, value) {
    var _a;
    const eventKey = `${String(group)}.${String(eventName)}`;
    (_a = _eventHandlers[eventKey]) === null || _a === void 0 ? void 0 : _a.forEach((handler) => {
        handler(value);
    });
}
